module.exports = __webpack_public_path__ + "img/weibo_on.f94324e8.png";